import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import {
  getFirestore,
  serverTimestamp,
} from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';

const productionConfig = {
  apiKey:   process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId,
};

const developmentConfig = {
  apiKey: 'AIzaSyDjILy2SoVHumUkTrkZiBTfeXhfEOWYEek',
  authDomain: 'combine-harvester.firebaseapp.com',
  projectId: 'combine-harvester',
  storageBucket: 'combine-harvester.appspot.com',
  messagingSenderId: '496478585142',
  appId: '1:496478585142:web:1e540ebad15022286fb397',
  measurementId: 'G-DPEVWTJKW1',
};

export const firebaseConfig =
  process.env.REACT_APP_ENV_TYPE === 'production'
    ? productionConfig
    : developmentConfig;

const app = !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app();

export const functions = getFunctions(app);
export const firestore = getFirestore(app);

// enableIndexedDbPersistence(firestore).catch((err) => {
//   if (err.code == 'failed-precondition') {
//     // Multiple tabs open, persistence can only be enabled
//     // in one tab at a a time.
//     // ...
//     alert('Multiple tabs are opened, please just use close one of it');
//   } else if (err.code == 'unimplemented') {
//     // The current browser does not support all of the
//     // features required to enable persistence
//     // ...
//     alert(
//       'This brower doesn\'t support all features of Combine Harvester. Please use chrome browser for the best experience.'
//     );
//   }
// });

export const auth = getAuth(app);
export const db = getFirestore(app);
export const currentTime = serverTimestamp();
export const pesistence = firebase
  .auth()
  .setPersistence(firebase.auth.Auth.Persistence.LOCAL);
export default app;
